// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallery-items[data-v-571d12a8]{margin:0 -15px;margin-bottom:10px;padding:0;-ms-flex-wrap:wrap;flex-wrap:wrap;max-height:400px;overflow:hidden;overflow-y:auto}.gallery-items[data-v-571d12a8],.pagination-container[data-v-571d12a8]{display:-webkit-box;display:-ms-flexbox;display:flex}.pagination-container>div[data-v-571d12a8]{width:100%}.pagination-container[data-v-571d12a8] .pagination{width:100%;padding:10px 0}.button-container .btn[data-v-571d12a8]{width:100%}", ""]);
// Exports
module.exports = exports;
